/* eslint no-console: 0 */
// Run this example by adding <%= javascript_pack_tag 'hello_vue' %> and
// <%= stylesheet_pack_tag 'hello_vue' %> to the head of your layout file,
// like app/views/layouts/application.html.erb.
// All it does is render <div>Hello Vue</div> at the bottom of the page.

import Vue from 'vue'
import VueRouter from 'vue-router'
import swal from 'sweetalert';
import Messenger from './messenger/messenger.vue'
import TextExcerpt from './text_excerpt.vue'
import Websocket from './websocket.js'
import JobInvitationProgress from './job_invitation_progress.vue'
import JobInvitationSubmit from './job_invitation_submit.vue'

window.websocket = new Websocket

Vue.use(VueRouter)
Vue.component('text-excerpt', TextExcerpt)
Vue.component('job-invitation-progress', JobInvitationProgress)
Vue.component('job-invitation-submit', JobInvitationSubmit)

var routes = [
  {
    path: '/messages',
    name: 'messages',
    component: Messenger
  },
  {
    path: '/messages/:chat_group_id',
    name: 'message',
    component: Messenger
  }
]

var router = new VueRouter({
  hashbang: false,
  mode: 'history',
  routes: routes
})

window.eventHub = new Vue()

var app = new Vue({
  router: router,
  props: ["currentUserId"]
}).$mount('#app')


// Replace the original confirm

$.rails.allowAction = function(link){
  if (link.data("confirm") == undefined) {
    return true;
  }

  if (link.data("stop-confirm") == true) {
    return true;
  }

  $.rails.showConfirmationDialog(link);

  return false;
}

//User click confirm button
$.rails.confirmed = function(link){
  link.data("stop-confirm", true)
  link.trigger("click.rails");
  link.data("stop-confirm", false)
}

//Display the confirmation dialog
$.rails.showConfirmationDialog = function(link){
  // var message = link.data("confirm");
  swal({
    title: link.data("confirm"),
    text: link.data("confirm-text"),
    icon: "warning",
    buttons: {
      cancel: {
        text: "取消",
        value: false,
        visible: true,
        className: "btn btn-lg btn-default",
        closeModal: true,
      },
      confirm: {
        text: "確定",
        value: true,
        visible: true,
        className: "btn btn-lg btn-primary",
        closeModal: true
      }
    },
    dangerMode: true
  }).then(function(e){
    if (e) {
      $.rails.confirmed(link);
    }
  });
};




// WEBPACK FOOTER //
// ./app/javascript/packs/app.js